import { Link } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { AlertTriangle, Loader2 } from 'lucide-react';

export default function DowngradePlanDialog({
  open,
  onOpenChange,
  loading,
  targetPlan,
  preview,
  onConfirm,
}) {
  const blocked = preview?.blocked || (preview?.conflicts?.length > 0);
  const conflicts = preview?.conflicts || [];
  const effectiveAt = preview?.effective_at
    ? new Date(preview.effective_at).toLocaleDateString()
    : 'the end of your billing period';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>
            {blocked ? 'Cannot downgrade yet' : `Downgrade to ${targetPlan?.name || 'plan'}`}
          </DialogTitle>
          <DialogDescription>
            {blocked
              ? 'Reduce resources below the new plan limits first.'
              : `Your plan will change on ${effectiveAt}.`}
          </DialogDescription>
        </DialogHeader>
        {blocked ? (
          <div className="space-y-3 py-2">
            <div className="flex gap-2 text-amber-700 dark:text-amber-400">
              <AlertTriangle className="w-5 h-5 shrink-0" />
              <p className="text-sm font-medium">Before downgrading, you need to:</p>
            </div>
            <ul className="text-sm space-y-2 list-disc pl-5 text-slate-600 dark:text-slate-400">
              {conflicts.map((c) => (
                <li key={c.type}>{c.message}</li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-2 pt-2">
              <Button variant="outline" size="sm" asChild>
                <Link to="/dashboard/spaces">Manage spaces</Link>
              </Button>
              <Button variant="outline" size="sm" asChild>
                <Link to="/dashboard/members">Manage members</Link>
              </Button>
            </div>
          </div>
        ) : (
          <p className="text-sm text-slate-600 dark:text-slate-400 py-2">
            Your current plan stays active until {effectiveAt}. No refund for the current period.
            Add-ons not available on {targetPlan?.name} will be removed on that date.
          </p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
            {blocked ? 'Close' : 'Cancel'}
          </Button>
          {!blocked && (
            <Button variant="destructive" onClick={onConfirm} disabled={loading}>
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Schedule downgrade
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
